<template>
  <div>
    <!-- 桌面版导航栏 -->
    <div class="page-header">
      <div class="center">
        <div class="logo">
          <a href="/">
            <img src="../../static/logo.png" />
          </a>
        </div>
        <div class="nav-container">
          <div class="link main-nav">
            <a v-for="(item,index) in languageNav[language]"
               :key="index"
               :class="[getNavItemClass(item), { 'ai-nav-item': item.hasAI }]"
               :href="item.anchor ? 'javascript:void(0)' : item.path"
               :target="item.external ? '_blank' : '_self'"
               @click="handleNavClick(item)">
              <span class="nav-text">{{item.name}}</span>
              <span v-if="item.hasAI" class="ai-badge">AI</span>
            </a>
          </div>
        </div>
        <div class="language">
          <b :class="language==='ch'?'on':''" @click="setLanguage('ch')">简</b>/
          <b :class="language==='hk'?'on':''" @click="setLanguage('hk')">繁</b>/
          <b :class="language==='en'?'on':''" @click="setLanguage('en')">English</b>
        </div>
      </div>
    </div>
    
    <!-- 移动版导航栏 - 汉堡菜单设计 -->
    <div class="mobile-header">
      <div class="mobile-nav-container">
        <!-- Logo -->
        <div class="mobile-logo">
          <a href="/">
            <img src="../../static/logo.png" />
          </a>
        </div>
        
        <!-- 汉堡按钮 -->
        <div class="hamburger-button" 
             :class="{ active: isMobileMenuOpen }"
             @click="toggleMobileMenu">
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
        </div>
      </div>
      
      <!-- 移动端导航菜单 -->
      <div class="mobile-nav-menu" 
           :class="{ active: isMobileMenuOpen }"
           @click="closeMobileMenu">
        <div class="mobile-nav-content" @click.stop>
          <!-- 移动端导航头部 - 只保留关闭按钮 -->
          <div class="mobile-nav-header">
            <div class="close-button-container">
              <button class="close-button" @click="closeMobileMenu">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
          
          <div class="mobile-nav-body">
            <!-- 导航链接 -->
            <div class="mobile-nav-links">
              <a v-for="(item,index) in languageNav[language]" 
                :key="index" 
                :href="item.anchor ? 'javascript:void(0)' : item.path"
                :target="item.external ? '_blank' : '_self'"
                :class="[getNavItemClass(item), { 'has-ai-badge': item.hasAI }]"
                @click="handleMobileNavClick(item)">
                <div class="nav-link-content">
                  <span class="nav-link-text">{{item.name}}</span>
                  <span v-if="item.hasAI" class="mobile-ai-badge">AI</span>
                </div>
              </a>
            </div>

            <!-- 简化的语言选择器 -->
            <div class="mobile-language-bar">
              <button :class="['language-btn', {active: language==='ch'}]" @click="setLanguage('ch')">简</button>
              <button :class="['language-btn', {active: language==='hk'}]" @click="setLanguage('hk')">繁</button>
              <button :class="['language-btn', {active: language==='en'}]" @click="setLanguage('en')">En</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    language: {
      type: String,
      default: 'ch'
    }
  },
  data() {
    return {
      isMobileMenuOpen: false,
      languageNav: {
        'ch': [{
          name: '首页',
          path: '/'
        }, {
          name: '公司介绍',
          path: '/',
          anchor: 'ujumedia1'
        }, {
          name: '优创',
          path: 'https://scriptv2.qfei.cn/welcome',
          external: true,
          hasAI: true
        }, {
          name: '服务与产品',
          path: '/products'
        }, {
          name: '联系我们',
          path: '/',
          anchor: 'ujumedia3'
        }, {
          name: '投资者关系',
          path: '/investor'
        }],
        'hk': [{
          name: '首頁',
          path: '/'
        }, {
          name: '公司簡介',
          path: '/',
          anchor: 'ujumedia1'
        }, {
          name: '優創',
          path: 'https://scriptv2.qfei.cn/welcome',
          external: true,
          hasAI: true
        }, {
          name: '服務與產品',
          path: '/products'
        }, {
          name: '聯繫我們',
          path: '/',
          anchor: 'ujumedia3'
        }, {
          name: '投資者關係',
          path: '/investor'
        }],
        'en': [{
          name: 'Home',
          path: '/'
        }, {
          name: 'About Us',
          path: '/',
          anchor: 'ujumedia1'
        }, {
          name: 'YouChuang',
          path: 'https://scriptv2.qfei.cn/welcome',
          external: true,
          hasAI: true
        }, {
          name: 'Services & Products',
          path: '/products'
        }, {
          name: 'Contact Us',
          path: '/',
          anchor: 'ujumedia3'
        }, {
          name: 'Investor relations',
          path: '/investor'
        }]
      }
    }
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
    // 初始化滚动状态
    this.handleScroll()
    // 监听ESC键关闭菜单
    document.addEventListener('keydown', this.handleKeyDown)
    // 监听路由变化关闭菜单
    this.$router.beforeEach((to, from, next) => {
      this.closeMobileMenu()
      next()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('keydown', this.handleKeyDown)
    // 清理body class
    document.body.classList.remove('mobile-menu-open')
  },
  methods: {
    setLanguage(val) {
      this.$emit('language-change', val)
      // 语言切换后关闭移动端菜单
      this.closeMobileMenu()
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      // 防止背景滚动
      if (this.isMobileMenuOpen) {
        document.body.classList.add('mobile-menu-open')
      } else {
        document.body.classList.remove('mobile-menu-open')
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      document.body.classList.remove('mobile-menu-open')
    },
    handleKeyDown(event) {
      // ESC键关闭菜单
      if (event.key === 'Escape' && this.isMobileMenuOpen) {
        this.closeMobileMenu()
      }
    },
    handleMobileNavClick(item) {
      // 先关闭菜单
      this.closeMobileMenu()
      // 然后处理导航
      setTimeout(() => {
        this.handleNavClick(item)
      }, 300) // 等待菜单关闭动画完成
    },
    handleScroll() {
      const header = document.querySelector('.page-header')
      const mobileHeader = document.querySelector('.mobile-header')
      
      // 如果是首页，使用特殊的透明处理逻辑
      if (this.$route.path === '/') {
        // 首页的滚动处理由页面自身控制
        return
      }
      
      // 其他页面的标准滚动处理
      if (window.scrollY > 100) {
        if (header) {
          header.classList.add('scrolled')
          header.classList.remove('hero-glass')
        }
        if (mobileHeader) {
          mobileHeader.classList.add('scrolled')
          mobileHeader.classList.remove('hero-glass')
        }
      } else {
        if (header) {
          header.classList.remove('scrolled')
          header.classList.remove('hero-glass')
        }
        if (mobileHeader) {
          mobileHeader.classList.remove('scrolled')
          mobileHeader.classList.remove('hero-glass')
        }
      }
    },
    scrollToSection(sectionId) {
      this.$emit('scroll-to-section', sectionId)
    },
    scrollToInvestorSection(sectionId, index) {
      // console.log('尝试滚动到投资者区域:', sectionId)
      // 更新激活的投资者子导航索引
      this.activeInvestorIndex = index
      
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          // console.log('找到投资者元素:', element, '位置:', element.offsetTop)
          const headerHeight = 200 // 投资者页面需要考虑导航栏和子导航的高度
          let top = element.offsetTop - headerHeight
          
          // 如果计算出的位置是负数，则滚动到页面顶部
          if (top < 0) {
            top = 0
          }
          
          // console.log('投资者页面滚动到位置:', top)
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        } else {
          console.error('找不到投资者页面ID为', sectionId, '的元素')
        }
      }, 100)
    },

    getNavItemClass(item) {
      // 精确匹配路由的选中状态
      if (item.path === this.$route.path && !item.anchor) {
        return 'on'
      }
      return ''
    },
    handleNavClick(item) {
      // 处理外部链接
      if (item.external) {
        window.open(item.path, '_blank')
        return
      }
      
      if (item.anchor) {
        // 如果当前不在首页，先跳转到首页
        if (this.$route.path !== '/') {
          this.$router.push('/').then(() => {
            setTimeout(() => {
              this.scrollToSection(item.anchor)
            }, 100)
          })
        } else {
          this.scrollToSection(item.anchor)
        }
      } else {
        // 普通路由跳转
        if (this.$route.path !== item.path) {
          this.$router.push(item.path)
        }
      }
    }
  }
}
</script>

<style scoped>
/* 现代化透明导航栏 */
.page-header{
    display: block;
    height: 80px;
    background: transparent;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9999;
    transition: all 0.3s ease;
    padding: 20px 40px;
}

/* 第一页完全透明效果 */
.page-header.hero-glass {
    background: transparent;
    backdrop-filter: none;
    box-shadow: none;
    border-bottom: none;
}

/* 其他页面白色背景 */
.page-header.scrolled {
    background: rgb(255 255 255 / 98%);
    backdrop-filter: blur(20px);
    box-shadow: 0 4px 20px rgb(0 0 0 / 10%);
    border-bottom: 1px solid rgb(0 0 0 / 10%);
}

.center{
    max-width: none;
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    background: transparent;
    backdrop-filter: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    position: relative;
    gap: 20px; /* 添加元素间距 */
}

.logo{
    display: flex;
    align-items: center;
    padding: 1px 20px;
    transition: all 0.3s ease;
    flex-shrink: 0; /* 防止logo收缩 */
    min-width: 120px; /* 确保logo有最小宽度 */
}

.logo img{
    height: 45px;
    width: auto;
    padding: 1px 12px;
    max-width: 220px;
    margin-top: 1px;
    object-fit: contain;
    object-position: left center;
    transition: transform 0.3s ease;
    filter: drop-shadow(0 2px 4px rgb(0 0 0 / 10%));
}

/* 导航容器布局 - 使用flex布局替代绝对定位 */
.nav-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    background: transparent;
    backdrop-filter: none;
    border-radius: 25px;
    padding: 5px 30px;
    box-shadow: none;
    border: none;
    transition: all 0.3s ease;
    flex: 1; /* 占据剩余空间 */
    min-width: 0; /* 允许收缩 */
    max-width: none; /* 移除最大宽度限制 */
    white-space: nowrap;
    z-index: 10;
    margin: 0 20px; /* 添加左右边距 */
}

.page-header.scrolled .nav-container {
    background: transparent;
    border: none;
    box-shadow: none;
}

/* hero-glass状态下的导航容器 */
.page-header.hero-glass .nav-container {
    background: transparent;
    border: none;
    box-shadow: none;
}

.nav-container:hover {
    background: transparent;
    box-shadow: none;
}

.page-header.hero-glass .nav-container:hover {
    background: transparent;
    box-shadow: none;
}

.page-header.scrolled .nav-container:hover {
    background: transparent;
    box-shadow: none;
}

.link {
    display: flex;
    align-items: center;
    gap: 15px;
    background: transparent;
    backdrop-filter: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    transition: none;
    position: static;
    left: auto;
    top: auto;
    transform: none;
    width: 100%;
    justify-content: center;
}

.link:hover {
    background: transparent;
    transform: none;
    box-shadow: none;
}

.main-nav {
    white-space: nowrap; /* 防止主导航换行 */
    flex-shrink: 0; /* 防止收缩 */
    display: flex;
    gap: 15px;
    flex-wrap: nowrap;
}

.main-nav a {
    font-size: 14px; /* 统一使用较小字体 */
    white-space: nowrap; /* 防止单个链接换行 */
    flex-shrink: 0; /* 防止链接收缩 */
}

.link a{
    color: #fff;
    font-size: 14px; /* 统一使用较小字体 */
    font-weight: 600;
    letter-spacing: 0.5px;
    padding: 8px 16px; /* 增加内边距使选中效果更明显 */
    border-radius: 20px; /* 增加圆角 */
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 优化动画曲线 */
    position: relative;
    background: transparent;
    border: 2px solid transparent; /* 增加边框宽度 */
    text-shadow: 0 1px 2px rgb(0 0 0 / 30%);
    white-space: nowrap; /* 防止链接文字换行 */
    flex-shrink: 0; /* 防止链接收缩 */
    text-decoration: none;
    display: inline-block;
}

.page-header.scrolled .link a {
    color: #2d3748;
    text-shadow: none;
}

.link a:hover{
    color: #fff;
    background: rgb(255 255 255 / 15%);
    border-color: rgb(255 255 255 / 40%);
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 25px rgb(255 255 255 / 20%);
}

.page-header.scrolled .link a:hover {
    color: #4f46e5;
    background: rgb(79 70 229 / 8%);
    border-color: rgb(79 70 229 / 25%);
    box-shadow: 0 8px 25px rgb(79 70 229 / 15%);
    transform: translateY(-2px) scale(1.02);
}

/* 选中状态 - 透明背景下（首页hero区域） */
.link a.on{
    color: #fff;
    background: rgb(255 255 255 / 25%);
    border-color: rgb(255 255 255 / 50%);
    box-shadow: 0 8px 25px rgb(255 255 255 / 25%);
    font-weight: 700;
    transform: translateY(-2px) scale(1.02);
    text-shadow: 0 2px 4px rgb(0 0 0 / 30%);
}

/* 选中状态 - 白色背景下（滚动后） */
.page-header.scrolled .link a.on {
    color: #4f46e5;
    background: rgb(79 70 229 / 8%);
    backdrop-filter: blur(20px);
    border-color: rgb(79 70 229 / 30%);
    box-shadow: 
        0 8px 32px rgb(79 70 229 / 12%),
        inset 0 1px 0 rgb(255 255 255 / 90%),
        inset 0 -1px 0 rgb(79 70 229 / 10%);
    font-weight: 700;
    transform: translateY(-2px) scale(1.02);
    text-shadow: none;
    position: relative;
}

/* 为玻璃效果添加伪元素 */
.page-header.scrolled .link a.on::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgb(255 255 255 / 40%) 0%, 
        rgb(255 255 255 / 10%) 50%,
        rgb(79 70 229 / 10%) 100%);
    border-radius: inherit;
    z-index: -1;
}

.language{
    display: flex;
    align-items: center;
    gap: 4px; /* 减小间隙使布局更紧凑 */
    background: transparent;
    backdrop-filter: none;
    padding: 5px 20px;
    border-radius: 25px;
    border: none;
    box-shadow: none;
    transition: all 0.3s ease;
    flex-shrink: 0; /* 防止收缩 */
    white-space: nowrap; /* 防止内容换行 */
    z-index: 5; /* 确保在主导航之下 */
    min-width: 120px; /* 确保语言切换器有足够空间 */
}

.page-header.scrolled .language {
    background: transparent;
    border: none;
}

/* hero-glass状态下的语言选择器 */
.page-header.hero-glass .language {
    background: transparent;
    border: none;
}

.language:hover{
    background: transparent;
    transform: none;
    box-shadow: none;
}

.page-header.hero-glass .language:hover {
    background: transparent;
    transform: none;
    box-shadow: none;
}

.page-header.scrolled .language:hover {
    background: transparent;
}

.language b{
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    padding: 6px 10px; /* 语言选择器使用较小的内边距 */
    border-radius: 12px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 与主导航保持一致的动画 */
    font-size: 14px; /* 统一字体大小 */
    border: 2px solid transparent;
    text-shadow: 0 1px 2px rgb(0 0 0 / 30%);
    white-space: nowrap; /* 防止换行 */
    flex-shrink: 0; /* 防止收缩 */
    text-decoration: none;
    display: inline-block;
}

.page-header.scrolled .language b {
    color: #718096;
    text-shadow: none;
}

.language b:hover{
    color: #fff;
    background: rgb(255 255 255 / 15%);
    border-color: rgb(255 255 255 / 40%);
    transform: translateY(-1px) scale(1.02);
}

.page-header.scrolled .language b:hover {
    color: #4f46e5;
    background: rgb(79 70 229 / 8%);
    border-color: rgb(79 70 229 / 25%);
    transform: translateY(-1px) scale(1.02);
}

/* 语言选择器选中状态 - 透明背景下 */
.language b.on{
    color: #fff;
    background: rgb(255 255 255 / 25%);
    border-color: rgb(255 255 255 / 50%);
    font-weight: 700;
    box-shadow: 0 4px 15px rgb(255 255 255 / 20%);
    transform: translateY(-1px) scale(1.02);
}

/* 语言选择器选中状态 - 白色背景下 */
.page-header.scrolled .language b.on {
    color: #4f46e5;
    background: rgb(79 70 229 / 8%);
    backdrop-filter: blur(15px);
    border-color: rgb(79 70 229 / 30%);
    box-shadow: 
        0 4px 20px rgb(79 70 229 / 12%),
        inset 0 1px 0 rgb(255 255 255 / 80%),
        inset 0 -1px 0 rgb(79 70 229 / 10%);
    font-weight: 700;
    transform: translateY(-1px) scale(1.02);
    position: relative;
}

/* 为语言选择器玻璃效果添加伪元素 */
.page-header.scrolled .language b.on::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgb(255 255 255 / 30%) 0%, 
        rgb(255 255 255 / 10%) 50%,
        rgb(79 70 229 / 5%) 100%);
    border-radius: inherit;
    z-index: -1;
}

/* 移动端导航 - 汉堡菜单设计 */
.mobile-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 70px;
    background: transparent;
    z-index: 1000;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    padding: 0 20px;
}

/* 移动端透明状态 */
.mobile-header.hero-glass {
    background: transparent;
    backdrop-filter: none;
    box-shadow: none;
    border-bottom: none;
}

/* 移动端滚动状态 */
.mobile-header.scrolled {
    background: rgb(255 255 255 / 95%);
    backdrop-filter: blur(20px);
    box-shadow: 0 4px 20px rgb(0 0 0 / 10%);
}

.mobile-nav-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Logo样式 */
.mobile-logo {
    flex-shrink: 0;
    z-index: 1002;
}

.mobile-logo img {
    height: 32px;
    width: auto;
    max-width: 120px;
    object-fit: contain;
    filter: drop-shadow(0 2px 8px rgb(0 0 0 / 20%));
    transition: all 0.3s ease;
}

.mobile-header.scrolled .mobile-logo img {
    filter: drop-shadow(0 1px 3px rgb(0 0 0 / 10%));
}

/* 汉堡按钮 */
.hamburger-button {
    width: 40px;
    height: 40px;
    background: rgb(255 255 255 / 10%);
    border: 2px solid rgb(255 255 255 / 30%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);
    z-index: 1002;
    position: relative;
    overflow: hidden;
}

.mobile-header.scrolled .hamburger-button {
    background: rgb(79 70 229 / 8%);
    border: 2px solid rgb(79 70 229 / 20%);
}

.hamburger-button:hover {
    background: rgb(255 255 255 / 20%);
    border-color: rgb(255 255 255 / 50%);
    transform: scale(1.05);
}

.mobile-header.scrolled .hamburger-button:hover {
    background: rgb(79 70 229 / 15%);
    border-color: rgb(79 70 229 / 40%);
}

.hamburger-button.active {
    background: rgb(255 255 255 / 90%) !important;
    border-color: rgb(255 255 255 / 90%) !important;
    transform: scale(1.1);
}

.hamburger-line {
    width: 20px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: center;
}

.mobile-header.scrolled .hamburger-line {
    background: #4f46e5;
}

.hamburger-button.active .hamburger-line {
    background: #4f46e5 !important;
}

.hamburger-button.active .hamburger-line:nth-child(1) {
    transform: translateY(6px) rotate(45deg);
}

.hamburger-button.active .hamburger-line:nth-child(2) {
    opacity: 0;
    transform: scaleX(0);
}

.hamburger-button.active .hamburger-line:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
}

/* 移动端导航菜单 */
.mobile-nav-menu {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 70%);
    backdrop-filter: blur(20px);
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
}

.mobile-nav-menu.active {
    opacity: 1;
    visibility: visible;
}

/* 防止背景滚动 */
body.mobile-menu-open {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
}

.mobile-nav-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: linear-gradient(160deg, #111827 0%, #1f2937 100%);
    transform: translateY(-100%);
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    max-width: 100% !important; /* 确保全屏宽度 */
}

.mobile-nav-menu.active .mobile-nav-content {
    transform: translateY(0);
}

/* 移动端导航头部 */
.mobile-nav-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px;
    border-bottom: 1px solid rgb(255 255 255 / 10%);
    background: transparent;
    width: 100%;
}

.close-button-container {
    margin-left: auto;
}

.close-button {
    width: 36px;
    height: 36px;
    background: rgb(255 255 255 / 20%);
    border: 2px solid rgb(255 255 255 / 30%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
}

.close-button:hover {
    background: rgb(255 255 255 / 30%);
    border-color: rgb(255 255 255 / 50%);
    transform: scale(1.05);
}

.mobile-nav-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    padding: 20px 0;
}

/* 导航链接区域 */
.mobile-nav-links {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0;
    padding: 40px 0; /* 增加上下间距 */
}

.mobile-nav-links a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    padding: 25px 20px; /* 增加上下间距 */
    margin: 0;
    border-radius: 0;
    text-decoration: none;
    color: #fff;
    font-size: 24px; /* 增大字体 */
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    transform: translateY(30px);
    animation: slideInFromBottom 0.5s ease-out forwards;
    border-bottom: 1px solid rgb(255 255 255 / 10%);
}

.mobile-nav-links a:last-child {
    border-bottom: none;
}

.mobile-nav-links a:nth-child(1) { animation-delay: 0.1s; }
.mobile-nav-links a:nth-child(2) { animation-delay: 0.15s; }
.mobile-nav-links a:nth-child(3) { animation-delay: 0.2s; }
.mobile-nav-links a:nth-child(4) { animation-delay: 0.25s; }
.mobile-nav-links a:nth-child(5) { animation-delay: 0.3s; }

@keyframes slideInFromBottom {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.mobile-nav-links a:hover {
    background: rgb(255 255 255 / 5%);
    color: #fff;
    transform: translateY(0);
}

.mobile-nav-links a.on {
    background: #4f46e5;
    color: #fff;
    box-shadow: 0 8px 30px rgb(79 70 229 / 30%);
}

.nav-link-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.nav-link-text {
    flex: 1;
    text-align: center;
}

.nav-link-arrow {
    width: 20px;
    height: 20px;
    color: #cbd5e0;
    transition: all 0.3s ease;
}

.mobile-nav-links a:hover .nav-link-arrow {
    color: #4f46e5;
    transform: translateX(4px);
}

/* 语言选择区域 */
.mobile-language-bar {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding: 40px 20px;
    width: 100%;
    opacity: 0;
    transform: translateY(30px);
    animation: slideInFromBottom 0.5s ease-out 0.4s forwards;
}

.language-btn {
    flex: 1;
    background: transparent;
    border: 1px solid rgb(255 255 255 / 20%);
    color: #fff;
    font-size: 18px; /* 增大语言按钮字体 */
    font-weight: 600;
    padding: 18px 20px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: inherit;
    max-width: 100px;
}

.language-btn:hover {
    background: rgb(255 255 255 / 10%);
    border-color: rgb(255 255 255 / 30%);
    color: #fff;
}

.language-btn.active {
    background: #4f46e5;
    border-color: #4f46e5;
    color: #fff;
    box-shadow: 0 4px 20px rgb(79 70 229 / 40%);
}

.language-text {
    flex: 1;
    text-align: left;
}

/* 移动端切换适配 */
@media screen and (width <= 1200px) {
    .center {
        padding: 0 20px;
        gap: 15px; /* 减小间距 */
    }
    
    .logo {
        min-width: 100px; /* 减小logo最小宽度 */
    }
    
    .nav-container {
        margin: 0 10px; /* 减小边距 */
        padding: 5px 15px; /* 减小内边距 */
    }
    
    .language {
        min-width: 100px; /* 减小语言切换器最小宽度 */
        padding: 5px 15px;
    }
}

/* 标准移动端样式 */
@media screen and (width <= 768px) {
    .page-header {
        display: none !important;
    }
    
    .mobile-header {
        display: flex !important;
    }
    
    /* 小屏幕手机优化 */
    .mobile-nav-content {
        width: 100vw;
        max-width: 360px;
    }
    
    .mobile-nav-links a {
        font-size: 28px; /* 更大的字体 */
        padding: 25px 20px;
    }
    
    .language-btn {
        padding: 18px;
        font-size: 20px;
    }
}

/* 超小屏幕适配 */
@media screen and (width <= 320px) {
    .mobile-nav-links a {
        font-size: 24px;
        padding: 20px 15px;
    }
    
    .language-btn {
        padding: 15px;
        font-size: 18px;
    }
}

/* 大屏幕移动设备适配 */
@media screen and (width <= 900px) and (width >= 769px) {
    .page-header {
        display: none !important;
    }
    
    .mobile-header {
        display: flex !important;
    }
}

/* 桌面端样式 */
@media screen and (width >= 901px) {
    .mobile-header {
        display: none !important;
    }
    
    .page-header {
        display: block !important;
    }
}

/* 横屏手机适配 */
@media screen and (height <= 500px) and (orientation: landscape) {
    .mobile-nav-content {
        width: 300px;
    }
    
    .mobile-nav-header {
        padding: 12px 20px;
    }
    
    .mobile-nav-links {
        padding: 16px 0;
        gap: 4px;
    }
    
    .mobile-nav-links a {
        padding: 12px 20px;
        font-size: 14px;
    }
    
    .mobile-language-section {
        padding: 16px 20px;
    }
    
    .language-btn {
        padding: 10px 16px;
    }
}

/* 桌面端特定样式优化 */
@media screen and (width >= 1200px) {
    .center {
        padding: 0 40px;
        gap: 30px; /* 增加间距 */
    }
    
    .link {
        gap: 40px;
    }
}

/* 小屏幕电脑自适应 */
@media screen and (width <= 1400px) and (width >= 901px) {
    .page-header {
        padding: 15px 20px;
    }
    
    .center {
        gap: 15px;
    }
    
    .logo {
        min-width: 100px;
    }
    
    .nav-container {
        margin: 0 15px;
        padding: 5px 20px;
    }
    
    .main-nav {
        gap: 10px;
    }
    
    .link a {
        font-size: 13px;
        padding: 6px 12px;
    }
    
    .language {
        min-width: 110px;
        padding: 5px 15px;
    }
    
    .language b {
        font-size: 13px;
        padding: 5px 8px;
    }
}

/* 中等屏幕 (1301px - 1400px) */
@media screen and (width <= 1400px) and (width >= 1301px) {
    .page-header {
        padding: 20px 30px;
    }
    
    .nav-container {
        margin: 0 20px;
        padding: 10px 16px;
    }
    
    .main-nav {
        gap: 12px;
    }
    
    .link a {
        font-size: 13px;
        padding: 5px 10px;
    }
    
    .language {
        padding: 10px 16px;
        gap: 3px;
    }
    
    .language b {
        font-size: 13px;
        padding: 5px 8px;
    }
}

/* 小屏幕 (1251px - 1300px) */
@media screen and (width <= 1300px) and (width >= 1251px) {
    .page-header {
        padding: 15px 20px;
    }
    
    .nav-container {
        margin: 0 15px;
        padding: 8px 14px;
    }
    
    .main-nav {
        gap: 10px;
    }
    
    .link a {
        font-size: 12px;
        padding: 4px 8px;
    }
    
    .language {
        padding: 8px 14px;
        gap: 2px;
    }
    
    .language b {
        font-size: 12px;
        padding: 4px 6px;
    }
}

/* 极小屏幕 (1201px - 1250px) */
@media screen and (width <= 1250px) and (width >= 1201px) {
    .page-header {
        padding: 15px 20px;
    }
    
    .nav-container {
        margin: 0 10px;
        padding: 8px 12px;
    }
    
    .main-nav {
        gap: 8px;
    }
    
    .link a {
        font-size: 11px;
        padding: 4px 6px;
    }
    
    .language {
        padding: 8px 12px;
        gap: 2px;
        min-width: 100px;
    }
    
    .language b {
        font-size: 11px;
        padding: 4px 5px;
    }
}

/* AI导航项样式 */
.ai-nav-item {
    position: relative;
    overflow: visible;
}

.nav-text {
    color: inherit;
}

.ai-badge {
    position: absolute;
    top: -12px;
    right: -6px;
    background: linear-gradient(45deg, 
        #ff6b6b 0%, 
        #4ecdc4 25%, 
        #45b7d1 50%, 
        #96ceb4 75%, 
        #feca57 100%);
    background-size: 200% 200%;
    color: white;
    font-size: 8px;
    font-weight: 900;
    padding: 3px 6px;
    border-radius: 10px;
    animation: aiGlow 3s ease-in-out infinite;
    box-shadow: 0 0 8px rgb(255 107 107 / 40%);
    text-shadow: none;
    border: 1px solid rgb(255 255 255 / 30%);
}

/* 透明背景状态下的AI标签样式 */
.page-header:not(.scrolled) .ai-badge {
    background: linear-gradient(45deg, 
        #fff 0%, 
        #f8f9fa 20%, 
        #e9ecef 40%, 
        #fff 60%, 
        #f1f3f4 80%, 
        #fff 100%);
    background-size: 200% 200%;
    color: #333;
    box-shadow: 0 0 12px rgb(255 255 255 / 90%), 
                0 0 20px rgb(255 255 255 / 70%);
    border: 1px solid rgb(255 255 255 / 80%);
}

/* 滚动后的AI标签样式 */
.page-header.scrolled .ai-badge {
    background: linear-gradient(45deg, 
        #ff6b6b 0%, 
        #4ecdc4 25%, 
        #45b7d1 50%, 
        #96ceb4 75%, 
        #feca57 100%);
    background-size: 200% 200%;
    color: white;
    box-shadow: 0 0 8px rgb(255 107 107 / 40%);
    border: 1px solid rgb(255 255 255 / 30%);
}

/* 移动端AI标签样式 */
.mobile-ai-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
    color: white;
    font-size: 8px;
    font-weight: bold;
    padding: 2px 4px;
    border-radius: 8px;
    animation: aiGlow 1.5s ease-in-out infinite alternate;
    box-shadow: 0 1px 4px rgb(102 126 234 / 30%);
    z-index: 10;
    transition: all 0.3s ease;
    border: 1px solid rgb(255 255 255 / 20%);
}

/* 移动端导航链接内容容器 */
.nav-link-content {
    position: relative;
    display: inline-block;
}

/* AI动画效果 */
@keyframes aiGlow {
    0%, 100% {
        background-position: 0% 50%;
        box-shadow: 0 0 8px rgb(255 107 107 / 40%), 0 0 16px rgb(255 107 107 / 20%);
    }

    50% {
        background-position: 100% 50%;
        box-shadow: 0 0 12px rgb(78 205 196 / 50%), 0 0 20px rgb(78 205 196 / 30%);
    }
}

/* 悬停效果 */
.ai-nav-item:hover .ai-badge {
    animation-duration: 1s;
    box-shadow: 0 0 15px rgb(255 107 107 / 60%), 0 0 25px rgb(78 205 196 / 40%);
    transform: scale(1.1);
}

.has-ai-badge:hover .mobile-ai-badge {
    animation-duration: 1s;
    box-shadow: 0 0 12px rgb(255 107 107 / 60%), 0 0 20px rgb(78 205 196 / 40%);
    transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue